"use client"

import { useLocation, useParams } from "react-router-dom"

import { extractWorkspaceSlugFromAdminPath } from "@/shared/lib/branch/branch-admin-routing"
import { useAuthContextStore } from "@/features/auth/services/auth-context-store"

export function useActiveWorkspaceSlug() {
  const params = useParams<{ workspaceSlug?: string }>()
  const location = useLocation()
  const activeWorkspaceSlug = useAuthContextStore((state) => state.activeWorkspaceSlug)
  const slugFromParams = params?.workspaceSlug ?? null
  const slugFromPath = extractWorkspaceSlugFromAdminPath(location.pathname) ?? null
  const resolvedWorkspaceSlug =
    slugFromParams ??
    slugFromPath ??
    activeWorkspaceSlug

  return resolvedWorkspaceSlug
}
